import {useMutation, UseMutationResult} from '@tanstack/react-query';
import raiseFlashMessage from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';
import creatorsUpdaters, {BulkEnqueuedResponse} from '@/api/updaters/creators';
import {invalidateCampaignInvitedQueriesAfterEnqueue} from '@/views/campaigns/creators-tab/utils/invalidateCampaignInvitedQueries';

export type InviteCreatorsToCampaignAllVariables = {
  agencyId: string;
  searchSessionId: string;
  campaignId: string;
  personalNote?: string;
};

function useInviteCreatorsToCampaignAll(): UseMutationResult<
  BulkEnqueuedResponse,
  Error,
  InviteCreatorsToCampaignAllVariables
> {
  return useMutation({
    mutationKey: ['creators', 'addToCampaignAll'],
    mutationFn: creatorsUpdaters.addToCampaignAll,
    onSuccess: () => {
      invalidateCampaignInvitedQueriesAfterEnqueue();
      raiseFlashMessage({
        status: 'success',
        message: translate(
          'Bulk invite to campaign enqueued for all matching creators'
        ),
      });
    },
  });
}

export default useInviteCreatorsToCampaignAll;
